<template>
  <div class="is-unselectable clickable flex" v-on="$listeners" :class="[css]">
    <i
      class="mdi-18px mdi mdi-checkbox-marked-circle margin-right-5"
      :class="checked ? 'has-text-success' : 'has-text-grey'"
    ></i>

    <span
      :class="[{ 'tooltip has-tooltip-multiline': tooltip }, [tooltipCss]]"
      :data-tooltip="tooltip"
    >
      <slot></slot>
    </span>
  </div>
</template>

<style lang="css">
.flex {
  display: flex;
  align-items: center;
}


</style>

<script>
export default {
  props: ["checked", "tooltip", "css", "tooltipCss"],
};
</script>
